import useSWR from 'swr';

import useSearchQuery from '@shared/v2/hooks/useSearchQuery';

import usePropertyContent from '@/components/PackagePage/hooks/usePropertyContent';
import { DEFAULT_SEARCH_PARAMS } from '@/constants';
import qs from '@/lib/qs';
import validateSearchQuery from '@/utils/validateSearchQuery';
import { UI } from '@/v2/types';

export type GetPackageOffersResponse = {
  packageOffers: UI.PackageOffer[];
  availability: unknown;
  totalFlightOptions?: number;
  flightOptions: UI.FlightOptions | undefined;
  qffPointTiers: UI.QFFPointTiersInstance | undefined;
};

export const useGetPackageOffersAndFlightOptions = () => {
  const { searchQuery } = useSearchQuery();
  const { originCode, departureDate, returnDate, adults, children, infants } =
    searchQuery || {};
  const propertyContent = usePropertyContent();
  const propertyId = propertyContent?.id;
  const destinationSearchConfig = propertyContent?.destination.searchConfig;

  const isValidSearchQuery =
    !!propertyId && validateSearchQuery(destinationSearchConfig, searchQuery);

  const { data, ...results } = useSWR<GetPackageOffersResponse>(() => {
    if (!isValidSearchQuery) {
      return null;
    }

    return qs.stringifyUrl({
      url: '/package/offers',
      query: {
        ...DEFAULT_SEARCH_PARAMS,
        propertyId: propertyId,
        destinationCode: destinationSearchConfig?.destinationCode,
        originCode,
        departureDate,
        returnDate,
        adults,
        children,
        infants,
      },
    });
  });

  return {
    data,
    searchQuery,
    isValidSearchQuery,
    ...results,
  };
};
